<div class="feed-page">
  <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
</div>
